import React from "react";
import ErrorBoundary from "./core/components/ErrorBoundary/ErrorBoundary";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import { theme } from "./styles";
import Main from "./Main";

const App = () => {
  return (
    <Router>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <ErrorBoundary>
            <Main />
          </ErrorBoundary>
        </ThemeProvider>
      </StyledEngineProvider>
    </Router>
  );
};
export default React.memo(App);
